import { fetchExcursionTypes } from './fetchExcursionTypes';
import { fetchExcursionRiskCategories } from './fetchExcursionRiskCategories';
import { fetchExcursionConfig } from './fetchExcursionConfig';
import { fetchExcursionMedicalConditions } from './fetchExcursionMedicalConditions';
import { patchExcursionStudentSelection } from './patchExcursionStudentSelection';

export default {
  fetchExcursionTypes,
  fetchExcursionRiskCategories,
  fetchExcursionConfig,
  fetchExcursionMedicalConditions,
  patchExcursionStudentSelection
};
